<script setup>
import { ref, onMounted } from 'vue';

const containerRef = ref();
const minWidthRef = ref(0);

const props = defineProps({
  cellWidth: {
    type: String,
    default: '200',
  },
});

onMounted(() => {
  const body = containerRef.value.querySelector('tbody');
  const firstRow = body.querySelector('tr');
  const cells = firstRow.querySelectorAll('td');
  const headercells = firstRow.querySelectorAll('th');

  let cols = 0;
  for (const cell of cells) {
    const colspan = cell.getAttribute('colspan');
    if (colspan) {
      cols += parseInt(colspan);
    } else {
      cols++;
    }
  }
  for (const hcell of headercells) {
    const colspan = hcell.getAttribute('colspan');
    if (colspan) {
      cols += parseInt(colspan);
    } else {
      cols++;
    }
  }
  minWidthRef.value = cols * parseInt(props.cellWidth);
});
</script>

<template>
  <div ref="containerRef" class="table-container">
    <div :style="'min-width: ' + minWidthRef + 'px;'">
      <table class="table">
        <slot />
      </table>
    </div>
  </div>
</template>
